import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CardDetailsCustomization = () => {
  const [cardDetails, setCardDetails] = useState({
    primaryColor: '#667eea',
    secondaryColor: '#764ba2',
    font: 'Arial',
    rewardType: 'Caffè',
    rewardCount: 10
  });
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCardDetails(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('cardDetails', JSON.stringify(cardDetails));
    navigate('/dashboard');
  };

  return (
    <div className="container">
      <div className="step-container">
        <div className="step-header">
          <span className="badge">Step 3</span>
          <h2>Personalizza i dettagli della tua card</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="primaryColor">Colore primario</label>
            <input type="color" id="primaryColor" name="primaryColor" value={cardDetails.primaryColor} onChange={handleInputChange} />
          </div>
          <div className="form-group">
            <label htmlFor="secondaryColor">Colore secondario</label>
            <input type="color" id="secondaryColor" name="secondaryColor" value={cardDetails.secondaryColor} onChange={handleInputChange} />
          </div>
          <div className="form-group">
            <label htmlFor="font">Font</label>
            <select id="font" name="font" value={cardDetails.font} onChange={handleInputChange}>
              <option value="Arial">Arial</option>
              <option value="Helvetica">Helvetica</option>
              <option value="Times New Roman">Times New Roman</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="rewardType">Tipo di premio</label>
            <input type="text" id="rewardType" name="rewardType" value={cardDetails.rewardType} onChange={handleInputChange} placeholder="Es. Caffè gratis" />
          </div>
          <div className="form-group">
            <label htmlFor="rewardCount">Numero di timbri per premio</label>
            <input type="number" id="rewardCount" name="rewardCount" value={cardDetails.rewardCount} onChange={handleInputChange} min="1" />
          </div>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button type="button" className="btn btn-secondary" onClick={() => navigate('/setup/card-layout')}>Indietro</button>
            <button type="submit" className="btn btn-primary">Finalizza</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CardDetailsCustomization;